import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/siteData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/90 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 items-center justify-between px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2.5" aria-label="包子漫画首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg text-background-50">
            包
          </span>
          <span
            className={`font-heading text-lg tracking-wide transition-colors ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
          >
            包子漫画
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                solid
                  ? "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                  : "text-background-100/90 hover:bg-white/10 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#download"
            className="hidden md:inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-download-2-line text-base" aria-hidden="true" />
            下载 APP
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="展开导航菜单"
            aria-expanded={open}
            className={`md:hidden flex h-10 w-10 items-center justify-center rounded-md transition-colors ${
              solid ? "text-foreground-900" : "text-background-50"
            }`}
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#download"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            <i className="ri-download-2-line text-base" aria-hidden="true" />
            下载 APP
          </a>
        </div>
      )}
    </header>
  );
}